export default __webpack_public_path__ + "static/media/smtp.51842dbb.pdf";